import templateUrl from './treat-information.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrationUnits: '<',
    categories: '<',
    copyAreas: '<',
    onProductLabelChanged: '&',
    locked: '<',
    viewOnly: '<',
    product: '<',
    unitsDisplay: '<',
    onDateFirstSoldChanged: '&',
    showHeader: '<',
    labelValid: '<'
  },
  controller: class TreatInformationComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.labelChanged = false;
      this.maxDate = new Date();
    }

    dateFirstSoldChanged(dateFirstSold) {
      this.onDateFirstSoldChanged(this.EventEmitter({
        dateFirstSold
      }));
    }

    productLabelChanged({ productLabel }) {
      this.labelChanged = true;
      this.onProductLabelChanged(this.EventEmitter({
        productLabel
      }));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/information/treat-information.component.js